import $ from 'jquery'

$(document).ready(function () {
  $('.dhsv_vc_easter_egg_img').click(function () {
    $('.dhsv_vc_easter_egg_img').addClass('stop_animation')
    $('.dhsv_vc_easter_egg_text_more').addClass('show_more')
    $('.dhsv_vc_easter_egg_slidein_animal').addClass('show_animal')
  })
})
